let initialized = false;

function getCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

function genEventId() {
  return window.crypto?.randomUUID
    ? window.crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function initTracking(settings) {
  if (initialized) return;
  initialized = true;
  const { meta_pixel_id, google_ads_id } = settings || {};

  if (meta_pixel_id) {
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", meta_pixel_id);
    window.fbq("track", "PageView");
  }

  if (google_ads_id) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${google_ads_id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", google_ads_id);
  }
}

// Espelha o evento no servidor (CAPI) com o mesmo event_id usado no Pixel,
// garantindo deduplicação entre os dois canais.
function mirrorToServer(name, eventId, extra) {
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track-event`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    keepalive: true,
    body: JSON.stringify({
      event_name: name,
      event_id: eventId,
      event_source_url: window.location.href,
      value: extra.value,
      currency: extra.currency,
      fbp: getCookie("_fbp"),
      fbc: getCookie("_fbc"),
    }),
  }).catch(() => {});
}

// Apenas eventos de topo/meio de funil. Purchase é exclusivamente server-side,
// disparado pelo webhook da Monetizze após confirmação real de pagamento.
export function trackEvent(name, extra = {}) {
  const eventId = genEventId();
  if (window.fbq && ["ViewContent", "InitiateCheckout", "PageView"].includes(name)) {
    window.fbq("track", name, extra, { eventID: eventId });
  }
  if (window.gtag) {
    window.gtag("event", name.toLowerCase());
  }
  if (name !== "PageView") {
    mirrorToServer(name, eventId, extra);
  }
}
